/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface IArgs {}

interface IconsSpinnerSignature {
  Element: SVGElement;

  Args: IArgs;

  Blocks: {
    default: [];
  };
}

const UiIconsSpinnerComponent = templateOnly<IconsSpinnerSignature>();

export default UiIconsSpinnerComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Icons::Spinner': typeof UiIconsSpinnerComponent;
  }
}
